import { render } from "./GoalsView.vue?vue&type=template&id=71e91886&scoped=true"
import script from "./GoalsView.vue?vue&type=script&lang=js"
export * from "./GoalsView.vue?vue&type=script&lang=js"

import "./GoalsView.vue?vue&type=style&index=0&id=71e91886&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-71e91886"

export default script